<template>
<div>
    <DashboardList/>
</div>
</template>

<script>
import DashboardList from '@/components/menuadmin/dashboard/DashboardList.vue'
export default {
    name: 'dashboard',
    components: {
        DashboardList,
    },
}
</script>
